export const themes: string[] = [
  'default',
  'dark'
];
